/**
 * Kalah (マンカラ・カラハ) の TypeScript 表現 (mixed-engine の serde 形と一致)。
 *
 * 盤 index:
 *   0..5  = First の P1..P6
 *   6     = First のストア (S1)
 *   7..12 = Second の P7..P12
 *   13    = Second のストア (S2)
 *
 * 反時計回り撒き、 自分のストア経由可、 相手ストアスキップ。
 * 最後の種が自ストア → free turn (= to_move flip しない)。
 * 最後の種が自陣空ピット → capture (= そこ + 対面相手ピットを自ストアへ)。
 */

export type Side = 'First' | 'Second';

export interface KalahConfig {
  initial_seeds: number;
  pie_rule: boolean;
  empty_capture: boolean;
}

export type KalahEndKind = 'Sweep' | 'Resign' | 'Timeout';

export type KalahOutcome =
  | { FirstWin: { margin: number; kind: KalahEndKind } }
  | { SecondWin: { margin: number; kind: KalahEndKind } }
  | { Draw: { kind: KalahEndKind } };

export interface KalahState {
  board: number[];          // length = 14
  to_move: Side;
  move_number: number;
  free_turn_streak: number; // UI 表示専用 (連続 free turn 数)
  swapped: boolean;
  outcome: KalahOutcome | null;
  config: KalahConfig;
}

export type KalahMove = { Sow: { pit: number } } | 'Swap';

export const N_PITS_TOTAL = 14;
export const N_PITS_SIDE = 6;
export const STORE_FIRST = 6;
export const STORE_SECOND = 13;

export function isSow(m: KalahMove): m is { Sow: { pit: number } } {
  return typeof m === 'object' && 'Sow' in m;
}

export function isSwap(m: KalahMove): boolean {
  return m === 'Swap';
}

/** `side` が sow 元として合法な pit index 範囲。 */
export function ownPitIndices(side: Side): number[] {
  return side === 'First' ? [0, 1, 2, 3, 4, 5] : [7, 8, 9, 10, 11, 12];
}

export function ownStoreIndex(side: Side): number {
  return side === 'First' ? STORE_FIRST : STORE_SECOND;
}
